var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShareBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#05c3de",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M 28.616 5.12395 L 23.3906 4.09595 L 23.796 8.59728"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#05c3de",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M 2.6814 26.66 L 8.63473 27.904 L 8.15606 23.4174"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#05c3de",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M 23.376 4.09595 C 29.1791 7.68387 31.5508 14.9325 28.9908 21.2567 C 26.4309 27.5809 19.6849 31.1389 13.02 29.6799"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#05c3de",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M 8.63469 27.904 C 2.83526 24.3193 0.461412 17.0781 3.01303 10.7557 C 5.56465 4.43334 12.2997 0.868374 18.9627 2.31332"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#05c3de",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M 18.6644 10.6666 H 15.8084 C 14.6622 10.667 13.6667 11.4552 13.4034 12.5707 C 13.1401 13.6862 13.6781 14.8364 14.7031 15.3493 L 17.3031 16.6506 C 18.328 17.1635 18.866 18.3137 18.6027 19.4292 C 18.3394 20.5447 17.3439 21.3329 16.1977 21.3333 H 13.3311"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#05c3de",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M 15.3364 21.3333 V 23.3333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#05c3de",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M 16.6697 8.66663 V 10.6666"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareBack);
export default __webpack_public_path__ + "static/media/share-back.9348c3fec1e17b22b784e45d9b47bde5.svg";
export { ForwardRef as ReactComponent };